import * as React from "react";
import {ERROR_COUNT_METRIC, GLOBAL_METRIC_KEY, logErrorMetric} from "../util/MetricUtil";
import {getStationCode} from "../network/NetworkUtil";
import {Logger} from "../util/Logger";

/**
 * Error boundary for logging unhandled exception metric during rendering, in lifecycle methods,
 * and in constructors of the whole tree below them.
 * https://reactjs.org/docs/error-boundaries.html
 */
export default class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {hasError: false};
    }

    static getDerivedStateFromError(error) {
        return {hasError: true};
    }

    componentDidCatch(error, errorInfo) {
        Logger.fatal("unhandled exception thrown in error boundary", error);
        logErrorMetric(getStationCode(), GLOBAL_METRIC_KEY, ERROR_COUNT_METRIC);
    }

    render() {
        if (this.state.hasError) {
            return <h1 style={{textAlign: "center"}}>Something went wrong!</h1>;
        }

        return this.props.children;
    }
}


// WEBPACK FOOTER //
// ./src/components/handler/ErrorBoundary.js